import useOrderVideoParams from "@/hooks/useOrderVideoParams";
import { useGetProductShippingQuery } from "@/redux/feature/orderManagement/productShipping/productShippingApi";

export const useProductShipping = (isOpen: boolean) => {
  const { orderId, videoId } = useOrderVideoParams();
  console.log(orderId, videoId);
  const { data: productShippingDetails, isLoading } =
    useGetProductShippingQuery(
      { orderId, videoId },
      {
        skip: !isOpen,
        refetchOnMountOrArgChange: true,
      }
    );
  console.log(productShippingDetails);
  return {
    productShippingData: productShippingDetails?.data,
    isDataLoading: isLoading,
  };
};
